// Side-effect import: Vite injects the stylesheet.
// oxlint-disable-next-line import/no-unassigned-import
import "./style.css";
import { GweledApp } from "./ui/app";

function reportStartupFailure(error: unknown): void {
  console.error("Gweled failed to start", error);
  const welcome = document.getElementById("welcome");
  if (!welcome) return;
  const message = document.createElement("p");
  message.className = "dialog-message";
  message.setAttribute("role", "alert");
  message.textContent =
    "Gweled could not start. Check that this browser supports WebGL, then reload the page.";
  welcome.append(message);
}

new GweledApp().start().catch(reportStartupFailure);
